/* eslint-disable jsx-a11y/media-has-caption */
import { LocalPlayerProps } from "./types";
import React, { useState } from "react";
import VideoPreviewImage from "./VideoPreviewImage";

const LocalPlayer = ({
  autoplay = false,
  loop = false,
  muted = false,
  previewImage,
  videoLocal,
}: LocalPlayerProps) => {
  const videoRef = React.useRef<HTMLVideoElement>(null);
  const playVideo = () => {
    if (videoRef?.current) {
      videoRef.current.play();
    }
  };
  const [videoStatus, setVideoStatus] = useState({
    started: autoplay,
    paused: false,
    play: false,
  });
  const hideAll = () => {
    return setVideoStatus({
      started: true,
      paused: false,
      play: false,
    });
  };
  const showPreviewImage = () => {
    return setVideoStatus({
      started: false,
      paused: false,
      play: false,
    });
  };
  const showCta = () => {
    return setVideoStatus({
      started: true,
      paused: true,
      play: false,
    });
  };
  return (
    <div className="Video">
      <video
        autoPlay={autoplay}
        className="Video__player"
        controls={videoStatus?.started ?? false}
        loop={loop}
        muted={muted}
        onEnded={showPreviewImage}
        onPause={showCta}
        onPlay={hideAll}
        ref={videoRef}
        src={videoLocal}
      />
      <VideoPreviewImage
        playVideo={playVideo}
        previewImage={previewImage}
        showPreviewImage={!(videoStatus?.started ?? false)}
        showCta={!videoStatus?.play}
      />
    </div>
  );
};

export default LocalPlayer;
